export const getCroppedImg = (imageSrc, croppedAreaPixels) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = imageSrc;
    image.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = croppedAreaPixels.width;
      canvas.height = croppedAreaPixels.height;
      const ctx = canvas.getContext('2d');

      ctx.drawImage(
        image,
        croppedAreaPixels.x,
        croppedAreaPixels.y,
        croppedAreaPixels.width,
        croppedAreaPixels.height,
        0,
        0,
        croppedAreaPixels.width,
        croppedAreaPixels.height
      );

      canvas.toBlob(blob => {
        if (blob) {
          resolve(new File([blob], 'cropped_image.jpeg', { type: 'image/jpeg' }));
        } else {
          reject(new Error('Canvas is empty'));
        }
      }, 'image/jpeg');
    };
    image.onerror = () => reject(new Error('Failed to load the image'));
  });
};

export const isArrayLength = arr => {
  // Check if the input parameter is an array and has a length greater than zero.
  return Array.isArray(arr) && (arr.length > 0 ?? false);
};

export const getEnumLabels = (listingFields = [], fieldKey, values = []) => {
  if (!Array.isArray(values) || !values.length) return [];

  const field = listingFields.find(f => f.key === fieldKey);
  if (!field || !Array.isArray(field.enumOptions)) return [];

  const optionMap = field.enumOptions.reduce((acc, opt) => {
    acc[opt.option] = opt.label;
    return acc;
  }, {});

  // keep same order as incoming values
  return values.map(v => optionMap[v]).filter(Boolean);
};

export const capitalizeFirst = str =>
  typeof str === 'string' && str.length ? str.charAt(0).toUpperCase() + str.slice(1) : str;

export const getServiceByIdOrDefault = (services = [], selectedServiceId) => {
  const list = Array.isArray(services) ? services : [];
  if (!list.length) return null;

  const match = selectedServiceId
    ? list.find(s => String(s?.id) === String(selectedServiceId))
    : null;

  return match;
};

export const getServicePrice = (service, fallback = 0) => {
  const p = service?.price;
  const num = typeof p === 'number' ? p : Number(p);
  return Number.isFinite(num) ? num : fallback;
};

const toInt = v => {
  const n = typeof v === 'number' ? v : Number(v);
  return Number.isFinite(n) ? n : null;
};

export const getGuestRange = (publicData = {}, activeService = null) => {
  const pdMin = toInt(publicData?.minGuests);
  const pdMax = toInt(publicData?.maxGuests);

  const sMin = toInt(activeService?.minGuests);
  const sMax = toInt(activeService?.maxGuests);

  const minGuests = sMin ?? pdMin;
  const maxGuests = sMax ?? pdMax;

  return { minGuests, maxGuests };
};

export const limitReviewLength = content => {
  if (!content || typeof content !== 'string') return '';

  const sentences = content
    .split(/([.!?])\s+/)
    .filter(Boolean)
    .reduce((acc, curr, idx) => {
      if (idx % 2 === 0) {
        acc.push(
          curr +
            (content.includes(curr + '.') ||
            content.includes(curr + '!') ||
            content.includes(curr + '?')
              ? ''
              : '.')
        );
      }
      return acc;
    }, []);

  // Take maximum 3 sentences and clean up
  const limited = sentences
    .slice(0, 3)
    .join(' ')
    .trim();

  // Ensure it ends with proper punctuation
  return limited.endsWith('.') || limited.endsWith('!') || limited.endsWith('?')
    ? limited
    : limited + '.';
};


export const getUserTypeDescription = (userType) => {
  const isChef = userType === 'private-chefs';
  
  return isChef 
    ? "Create your profile and receive booking requests."
    : "Book a private chef for your event.";
};